define(
    'viewmodels/secured/libraries/create/fromTemplate/wizard',[
        "viewmodels/ViewModel",
        "providers/dataprovider",
        "i19n!i19n/strings",

        "viewmodels/secured/libraries/create/fromTemplate/select/select",
        "viewmodels/secured/libraries/create/fromTemplate/name/name",
        "viewmodels/secured/libraries/create/fromTemplate/list/list",
        "viewmodels/secured/libraries/create/fromTemplate/confirm/confirm"
    ],
    function (
        ViewModel,
        dataProvider,
        i19n,

        step1,
        step2,
        step3,
        step4

        ){

        var vm = new ViewModel(
        {
            step1: step1,
            step2: step2,
            step3: step3,
            step4: step4
        });
        
        vm.activate = function (title, description, fields, list, template, templateId, defaultName) {
            var longtitle = String.format(i19n.to.createanewemptylibraryusingtheblueprint, title);
            
            vm.step1.title(longtitle);
            vm.step1.details(description, fields, list, template);
            vm.step2.title(longtitle);
            
            vm.step2.defaultName(defaultName);

            vm.step3.title(longtitle);
            vm.step3.listOptionText(String.format(i19n.to.createanduseanewlistcalled_asdefinedinthisblueprint, list));
            vm.step3.listNew(title);
            vm.step3.templateOptionText(String.format(i19n.to.copythe_documenttemplatesinto, '5'));
            vm.step3.defaultList(list);
            
            vm.step4.templateId(templateId);
        }

        return vm;
    }
);
